<atx-media-preview
  [media]="media"
  [videoAttributes]="videoAttributes"
  [startVideoAdvancedBy]="startVideoAdvancedBy"
  [activateOnMouseEnter]="activateOnMouseEnter"
  [objectFit]="objectFit"
  [maxWidth]="maxWidth"
>
</atx-media-preview>
